<template>
  <a-layout>
    <a-layout-header class="headBar">
      <a-row>
        <a-col :span="6">
          <img
            :src="base_url() + '/static/img/banner.png'"
            width="250"
            style="margin-left: 30px;"
            @click="goTo"
          />
        </a-col>
        <a-col :span="6"></a-col>
      </a-row>
    </a-layout-header>
  </a-layout>
</template>

<script>
export default {
  methods: {
    goTo () {
      if (this.$route.meta.id > 0) {
        window.location = this.base_url() + '/admin'
      } else {
        window.location = this.base_url()
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/header.vue